module.exports = __webpack_public_path__ + "media/images/google_plus-5f3407ff35389c5ab31b4824c273ce5f.png";